export { PhrasebookPage as default, getServerSideProps } from 'src/features/Phrasebook';
